import { Component } from '@angular/core';
import { Input } from '@angular/core';

@Component({
    selector: 'app-errormessage',
    templateUrl: './errormessage.component.html',
    styleUrls: ['./errormessage.component.scss']
})
export class ErrorMessageComponent {
    @Input()
    public serverErrorMessage: string;
    @Input()
    public errorMessageTranslationKey: string;


    ngOnInit() {
        if(this.serverErrorMessage=="This session is sold out, so new registrations aren't allowed." && this.errorMessageTranslationKey==null)
        {
            this.errorMessageTranslationKey="MaximumSessionCapacityReachedMaketingForm";
        }
    }
}
